import { removeNonNumbers } from '@ott/transforms';

const onlyDigits = (v: string): string => v && removeNonNumbers(v);

export const parseCVV = (v: string): string => v && onlyDigits(v).substr(0, 4);
export const formatCVV = (v: string): string => v && removeNonNumbers(v);
